import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// i18next
import { useTranslation } from 'react-i18next';
// MUI
import { Box, FormHelperText, Typography } from '@mui/material';
// Components
import { DesktopDatePicker, Input } from 'app/components/Mui';
// Utilities
import {
  isDateOfBirthValid,
  isDateValid,
  isMaxLength
} from 'app/utilities/Validations';

const ClaimantStep:FC = () => {
  const { t } = useTranslation();

  const { control, formState: { errors }, watch } = useFormContext();

  const watchedClaimantName = watch('caseData.claimant.name');

  return (
    <Box sx={{ mt: 4 }}>
      <Typography sx={{
        fontSize: { xs: 13, sm: 15 },
        lineHeight: '150%',
        letterSpacing: '0.15px',
        color: 'rgb(33, 33, 38)'
      }}>To help us better identify and process your case, you may provide the following details:</Typography>
      <Controller
        control={control} name="caseData.claimant.name"
        rules={{ maxLength: isMaxLength(31) }}
        render={({ field }) => (
          <Input
            {...field}
            label="Claimant Full Name"
            error={Boolean((errors.caseData as any)?.claimant?.name)}
            helperText={(errors.caseData as any)?.claimant?.name?.message || ''}
            slotProps={{
              input: {
                endAdornment: (
                  <FormHelperText
                    sx={{ p: 0, whiteSpace: 'nowrap' }}
                  >{`${watchedClaimantName.length} / 31`}</FormHelperText>
                )
              }
            }}
          />
        )}
      />
      <Controller
        control={control} name="caseData.claimant.dateOfBirth"
        rules={{
          validate: isDateOfBirthValid
        }}
        render={({ field }) => (
          <DesktopDatePicker
            {...field}
            label={t('labels.dateOfBirth')}
            slotProps={{
              textField: {
                error: Boolean((errors.caseData as any)?.claimant?.dateOfBirth),
                helperText: (errors.caseData as any)?.claimant?.dateOfBirth?.message || ''
              }
            }}
          />
        )}
      />
      <Controller
        control={control} name="caseData.eventDate"
        rules={{
          validate: isDateValid
        }}
        render={({ field }) => (
          <DesktopDatePicker
            {...field}
            label={t('labels.eventDate')}
            slotProps={{
              textField: {
                error: Boolean((errors.caseData as any)?.eventDate),
                helperText: (errors.caseData as any)?.eventDate?.message || ''
              }
            }}
          />
        )}
      />
      <Typography sx={{
        fontSize: { xs: 13, sm: 15 },
        lineHeight: '150%',
        letterSpacing: '0.15px',
        color: 'rgb(33, 33, 38)'
      }}>This information is optional and can be added later if you prefer.</Typography>
    </Box>
  )
}

export default ClaimantStep;
